import { PageType } from '@app/config';
import usePageConfig from '../usePageConfig';

const usePageType = (): PageType => usePageConfig()?.type ?? PageType.Other;

export default usePageType;
